import React from "react"
import { defaultConfig, FrontendConfig } from "../../models/config"

const ConfigContext = React.createContext<FrontendConfig>(defaultConfig)

export default ConfigContext
